/**
 * Format bytes to human-readable file size
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};

/**
 * Format seconds to MM:SS duration
 */
export const formatDuration = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  const hoursStr = hours > 0 ? `${hours}h ` : "";
  const minsStr = mins > 0 ? `${mins}m ` : "";
  const secsStr = `${secs}s`;

  return `${hoursStr}${minsStr}${secsStr}`.trim();
};

/**
 * An amount in `currency`, written the way `language` writes money ("1 250 €"
 * in French, "€1,250" in English). A currency code Intl does not know (a typo
 * in a preference) falls back to euros rather than throwing a RangeError out
 * of a render.
 */
export const formatCurrency = (
  value: number,
  language: string,
  currency = "EUR",
  options: Intl.NumberFormatOptions = {},
): string => {
  const format = (code: string) =>
    new Intl.NumberFormat(language, {
      style: "currency",
      currency: code,
      ...options,
    }).format(value);
  try {
    return format(currency);
  } catch {
    return format("EUR");
  }
};
